import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pa-2",
  style: {"width":"50%"}
}

import { AssetManagementPlan } from "@/classes";
import RichText from "@/components/base/inputs/RichText.vue";
import RACIMatrix from "../raci/RACIMatrix.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffRACI',
  props: {
    plan: {},
    diffPlan: {},
    diff: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.raci ?? '',
      "diff-value": _ctx.diffPlan?.raci,
      label: "2.1 RACI",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RACIMatrix, {
      plan: _ctx.plan,
      readonly: ""
    }, null, 8, ["plan"])
  ]))
}
}

})